import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl99WithFileValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocPraktFile: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    docPraktFileDate: yup.date().typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")).required(t("Το πεδίο είναι υποχρεωτικό")),
    d55_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocLoipa: yup
      .string()
      .notRequired()
      .test(
        "fudocLoipa-check",
        t("Εισάγατε ημερομηνία Λοιπών Εγγράφων αλλά όχι και το έγγραφο."),
        (value, context) => {
          const { docLoipaFileDate, fudocLoipa } = context.parent;
          return !(!fudocLoipa && docLoipaFileDate);
        },
      ),
    docLoipaFileDate: yup
      .date().typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .notRequired()
      .test(
        "docLoipaFileDate-check",
        t("Εισάγατε Λοιπά Έγγραφα αλλά όχι και την ημερομηνία του Εγγράφου."),
        (value, context) => {
          const { fudocLoipa, docLoipaFileDate } = context.parent;
          return !(!docLoipaFileDate && fudocLoipa);
        },
      ),
  });
};
